import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { suitServices } from '../../../mocks/trajesMedida';

export default function ServicesSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="w-full bg-white py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="text-center max-w-3xl mx-auto" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Servicios
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2.2rem,4.5vw,3.2rem)] font-semibold leading-[1.15] mt-4">
            Sastrería de Alta Costura
            <span className="italic text-brand-gray-300"> para Hombre</span>
          </h2>
          <p className="font-sans text-brand-gray-500 text-[15px] leading-[1.8] mt-5">
            Cada traje es un proyecto artesanal que requiere semanas de dedicación.
            Ofrecemos un servicio integral, desde el primer boceto hasta el ajuste final.
          </p>
        </div>

        <div className="mt-14 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {suitServices.map((service, index) => (
            <div
              key={service.id}
              className="group bg-brand-gray-50 rounded-3xl p-7 md:p-8 border border-transparent hover:border-brand-gray-100 transition-all duration-500 hover:-translate-y-1"
              style={isVisible ? {
                opacity: 1,
                transform: 'translateY(0px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 120}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 120}ms`,
              } : {
                opacity: 0,
                transform: 'translateY(36px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 120}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 120}ms`,
                willChange: 'opacity, transform',
              }}
            >
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 group-hover:bg-brand-black transition-colors duration-300">
                <i className={`${service.icon} text-brand-black text-lg group-hover:text-white transition-colors duration-300`} />
              </div>
              <h3 className="font-serif text-brand-black text-xl font-medium leading-[1.4]">
                {service.title}
              </h3>
              <p className="font-sans text-brand-gray-500 text-[14px] leading-[1.7] mt-3">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}